import { render, staticRenderFns } from "./t-editor.vue?vue&type=template&id=404b80c0&"
import script from "./t-editor.vue?vue&type=script&lang=js&"
export * from "./t-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports